import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';
import CreateStoreForm from './CreateStoreForm';

const CreateStorePopup = ({ store }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {store?.storeId ? (
        <Button
          type="button"
          className="badge btn btn-success py-2"
          onClick={toggle}
        >
          <i className="ri-edit-2-line fs-18"></i>
        </Button>
      ) : (
        <Button
          size="sm"
          color="info"
          onClick={toggle}
          className="d-flex align-items-center gap-1"
        >
          <i className="bx bx-plus"></i> Create Store
        </Button>
      )}

      <Modal
        size="lg"
        isOpen={isOpen}
        toggle={toggle}
        backdrop="static"
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={toggle} className="border-bottom pb-3">
          {store?.storeId ? store?.name : 'Create New Store'}
        </ModalHeader>
        <ModalBody>
          <CreateStoreForm handleClose={toggle} store={store} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default CreateStorePopup;
